/* unplugin-vue-components disabled */import { render } from "./skill-editor.vue?vue&type=template&id=68488933&scoped=true"
import script from "./skill-editor.vue?vue&type=script&lang=js"
export * from "./skill-editor.vue?vue&type=script&lang=js"

import "./skill-editor.vue?vue&type=style&index=0&id=68488933&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68488933"],['__file',"src/pages/settings/admin/test-skills/skill-editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68488933"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68488933', __exports__)) {
    api.reload('68488933', __exports__)
  }
  
  module.hot.accept("./skill-editor.vue?vue&type=template&id=68488933&scoped=true", () => {
    api.rerender('68488933', render)
  })

}


export default __exports__